import { action, computed, makeObservable, observable } from 'mobx';
const storage = localStorage;
const ACCESS_TOKEN = 'accessToken';
export class Auth {
  @observable accessToken = storage.getItem(ACCESS_TOKEN) || '';
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  @observable userInfo =
    (storage.getItem('userInfo') &&
      JSON.parse(storage.getItem('userInfo') as string)) ||
    {};
  constructor() {
    makeObservable(this);
  }

  @action
  setUserInfo = (token: string, userInfo?: { userName: string }) => {
    try {
      storage.setItem(ACCESS_TOKEN, token);
      if (userInfo) {
        storage.setItem('userInfo', JSON.stringify(userInfo));
      }
    } finally {
      this.accessToken = token;
      this.userInfo = userInfo;
    }
  };
  @action clealAccessToken = () => {
    try {
      storage.removeItem(ACCESS_TOKEN);
      storage.removeItem('userInfo');
    } finally {
      this.accessToken = '';
      this.userInfo = {};
    }
  };
  @action
  getToken = () => {
    return this.accessToken;
  };

  @computed
  get loggedIn(): boolean {
    return !!this.accessToken;
  }
}

export default new Auth();
